import { createContext, useCallback, useContext } from 'react';
import { calculateEstimatedDeliveryDate } from '../utils/productHelper';

const ShopContext = createContext();

export const ShopProvider = ({ children }) => {
  const commonDeliveryDates = {
    2: calculateEstimatedDeliveryDate(2),
    6: calculateEstimatedDeliveryDate(6),
  };

  const getEstimatedDeliveryDate = useCallback((product) => {
    if (
      !product.shippable ||
      typeof product.estimatedDeliveryDays !== 'number'
    ) {
      return null;
    }

    return (
      commonDeliveryDates[product.estimatedDeliveryDays] ??
      calculateEstimatedDeliveryDate(product.estimatedDeliveryDays)
    );
  }, []);

  return (
    <ShopContext.Provider
      value={{
        commonDeliveryDates,
        getEstimatedDeliveryDate,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
